"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _BreadcrumbList = _interopRequireDefault(require("./BreadcrumbList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var breadcrumbTrimPlaceholder = '...';
var _generateBreadCrumbs = function generateBreadCrumbs(pageItem) {
  var breadcrumbs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (pageItem.field) breadcrumbs.push(crumbItem({
    pageItem
  }));
  if (pageItem.parent) _generateBreadCrumbs(pageItem.parent, breadcrumbs);
  return breadcrumbs;
};
var trimBreadcrumbs = breadcrumbs => {
  if (breadcrumbs.length <= 6) return breadcrumbs;
  return [breadcrumbs[0], breadcrumbTrimPlaceholder, ...breadcrumbs.slice(-5)];
};
var crumbItem = props => {
  return {
    targetLink: props.pageItem.url ? props.pageItem.url.toLowerCase() : '',
    //URL won't be avilable for current page
    label: (0, _lodash.isEmpty)(props.pageItem.field.pageName) ? props.pageItem.name : props.pageItem.field.pageName
  };
};
var Breadcrumb = props => {
  if (!props || !props.rendering || !props.rendering.fields || !props.rendering.fields.data || !props.rendering.fields.data.contextItem) return null;
  var breadcrumbs = _generateBreadCrumbs(props.rendering.fields.data.contextItem);
  if (breadcrumbs.length > 1) {
    var breadcrumbProps = {
      breadcrumbs: trimBreadcrumbs(breadcrumbs.reverse()),
      breadcrumbTrimPlaceholder
    };
    return /*#__PURE__*/_react.default.createElement("nav", {
      "aria-label": "max level trumcated breadcrumb",
      class: "main-breadcrumb container"
    }, /*#__PURE__*/_react.default.createElement(_BreadcrumbList.default, breadcrumbProps));
  } else return null;
};
var _default = exports.default = Breadcrumb;